import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClientCoreModule, CommonUtilityLib, MatComponentsModule } from '@thehubz/client/core';
import { LeftMenuComponent, MenuItemsComponent, MenuSubItemsComponent } from './components';

@NgModule({
  imports: [CommonModule, MatComponentsModule, ClientCoreModule, RouterModule],
  declarations: [LeftMenuComponent, MenuItemsComponent, MenuSubItemsComponent],
  exports: [LeftMenuComponent, MenuItemsComponent],
  providers: [CommonUtilityLib],
})
export class ClientLeftNavModule {}
